export default __webpack_public_path__ + "static/rh-white-montserrat-v5-b13aacffb7c1824e6fd1af89d7df40c7.svg";